import React from "react";
import { Sun, Moon } from "lucide-react";
import { useSiteTheme } from "../lib/siteTheme";

export default function SiteThemeToggle({ className = "" }) {
  const { isDark, toggle } = useSiteTheme();
  return (
    <button type="button" onClick={toggle} data-testid="site-theme-toggle" aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"} title={isDark ? "Tema claro" : "Tema escuro"}
      className={`grid place-items-center h-8 w-8 rounded-full ring-1 ring-slate-200 text-slate-500 hover:text-slate-900 hover:bg-slate-50 transition-colors ${className}`}>
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
